import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=56f0c180&"
import script from "./ForgotPassword.vue?vue&type=script&lang=js&"
export * from "./ForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=56f0c180&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f0c180')) {
      api.createRecord('56f0c180', component.options)
    } else {
      api.reload('56f0c180', component.options)
    }
    module.hot.accept("./ForgotPassword.vue?vue&type=template&id=56f0c180&", function () {
      api.rerender('56f0c180', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/authentication/ForgotPassword.vue"
export default component.exports